import {Card, Button, message, Modal, DatePicker, Input, Space, Typography } from "antd";
import { useState, useEffect } from "react";
import moment from "moment-timezone";
import API from "../../../services/API";
import Data from "../../CustomText/data";
import { isSupportLead, isSupportManager } from "../../../helpers/roleStore";


const { Text } = Typography;

function HighRiskRules({ userId, onRulesLoaded }) {
  const [highRiskRules, setHighRiskRules] = useState([]);
  const [loading, setLoading] = useState(false);
  
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRule, setSelectedRule] = useState(null);
  const [expirationDate, setExpirationDate] = useState(null);
  const [comment, setComment] = useState('');
  const [ModalLoading, setModalLoading] = useState(false);

  const getHighRiskRules = async (userId) => {
    try {
      setLoading(true);
      let res = await API.getHighRiskRules(userId);
      setHighRiskRules(res.rules || []);
      if (onRulesLoaded) onRulesLoaded(res.rules || []);
    } catch (error) {
      message.error("Unable to fetch high-risk rules", error);
      console.error("Unable to fetch high-risk rules", error)
    } finally {
      setLoading(false);
    }
  };

  const handleAllowlistRule = (rule) => {
    setSelectedRule(rule);
    const tomorrow = moment().add(1, 'day'); // default to one day
    setExpirationDate(tomorrow);
    setComment('');
    setModalOpen(true);
  };

  const submitAllowlistRule = async () => {
    if (!selectedRule || !expirationDate) {
      message.error("Please fill in all required fields");
      return;
    }

    try {
      setModalLoading(true);
      await API.allowlistRule(
        userId,
        selectedRule.ruleId,
        selectedRule.ruleName,
        expirationDate.toISOString(),
        comment
      );
      message.success("Rule successfully allowlisted. Re-run a profile audit to clear the user.");
      setModalOpen(false);
      getHighRiskRules(userId);
    } catch (error) {
      message.error("Unable to allowlist rule");
    } finally {
      setModalLoading(false);
    }
  };

  const closeAllowlistModal = () => {
    setModalOpen(false);
    setSelectedRule(null);
    setExpirationDate(null);
    setComment('');
  };

  useEffect(() => {
    if (userId) {
      getHighRiskRules(userId);
    }
  }, [userId]);

  if (loading) {
    return <div>Loading high-risk rules...</div>;
  }

  if (!highRiskRules || highRiskRules.length === 0) {
    return null;
  }

  return (
    <>
      <Card 
        bordered={false} 
        className="mb-24"
        style={{
          border: '2px solid #ff4d4f',
          backgroundColor: '#fff2f0'
        }}
      >
          <h2 style={{color: "#ff4d4f", padding: '5px'}}>
            Background Check Issues
          </h2>
          <Space direction="vertical" style={{ width: "100%" }}>
            {highRiskRules.map((rule) => (
              <Card key={rule.ruleId}>
                <Space direction="horizontal" style={{ width: "100%", justifyContent: "space-between" }}>
                    <Data title="ID" value={rule.ruleId} />
                    <Data title="Name" value={rule.ruleName} />
                  {(isSupportLead() || isSupportManager()) && 
                    <Button 
                      type="primary" 
                      onClick={() => handleAllowlistRule(rule)}
                    >
                    Temporarily Allow
                  </Button>}
                </Space>
              </Card>
            ))}
          </Space>
      </Card>

      <Modal
        title={`Temporarily Allow Rule: ${selectedRule?.ruleName}`}
        open={modalOpen}
        onOk={submitAllowlistRule}
        onCancel={closeAllowlistModal}
        confirmLoading={ModalLoading}
        okText="Allow Rule"
        cancelText="Cancel"
      >
        <Space direction="vertical" style={{ width: '100%' }}>
          <div>
            <Text strong>Rule ID:</Text> {selectedRule?.ruleId}
          </div>
          <div>
            <Text strong>Rule Name:</Text> {selectedRule?.ruleName}
          </div>
          <div>
            <Text strong>Allowance Expiration Date:</Text>
            <DatePicker
              style={{ width: '100%', marginTop: '8px' }}
              showTime
              value={expirationDate}
              onChange={(date) => setExpirationDate(date)}
              placeholder="Select expiration date"
            />
          </div>
          <div>
            <Text strong>Comment (optional):</Text>
            <Input.TextArea
              style={{ marginTop: '8px' }}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Why you're allowing this rule"
              rows={3}
            />
          </div>
          <div>
            <Text type="danger">Re-run a profile audit to clear the user. If allowlisting multiple rules, you only need to do this once at the end.</Text>
          </div>
        </Space>
      </Modal>
    </>
  );
}

export default HighRiskRules;
